export const GoBackIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs></defs>
      <g
        id="Raggruppa_1190"
        data-name="Raggruppa 1190"
        transform="translate(-27 -566)"
      >
        <g
          id="Raggruppa_926"
          data-name="Raggruppa 926"
          transform="translate(110.94 1237) rotate(180)"
        >
          <path
            id="Tracciato_258"
            data-name="Tracciato 258"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(64.5 650.741)"
            stroke-linecap="round"
            stroke-width="1.5"
            fill="none"
            style={{ stroke: "rgb(48, 49, 48)" }}
          ></path>
          <path
            id="Tracciato_259"
            data-name="Tracciato 259"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(70.5 650.741)"
            stroke-linecap="round"
            stroke-width="1.5"
            fill="none"
            style={{ stroke: "rgb(48, 49, 48)" }}
          ></path>
        </g>
      </g>
    </svg>
  );
};
